// Step 1: Filename and alt text mapping
const imageAltMap = {
  "Brochure_v3_540x.progressive.jpg": "UGG Ozwear",
  "mamamia_post_large.jpg": "UGG boots for winter season",
  "20240626_OZwear_AW2416699.jpg": "UGG Ashton Mini Boots ideal for colder weather",
  "mwa_2017_large.JPG": "Ozwear UGG as a title sponsor of Miss World Australia 2017",
  "IMG_0859_large.JPG": "Ozwear UGG as sponsor in Cosmopolitan Model Search 2015",
  "Rocky_Gathercole_480x480.png": "Miss World Australia / Very Gathercole by Rocky Gathercole Fashion Event",
  "20240626_OZwear_AW2415159.jpg": "Ozwear Coquette Shearling Mule",
  "IMG_1178_large.jpg": "Ozwear UGG as sponsor in Miss Australia Chinese Pageant 2015",
  "ESMA_1f3bcc86-1fc6-43c8-ad1d-e41d3628a5c2_large.png": "Esma Voloder wearing Ozwear UGG boots",
  "013_480x480.jpg": "UGG Classic Men's Mini Boots",
  "scarf_copy_large.jpg": "Miss World Australia winner Esma Voloder wearing Ozwear UGG boots",
  "teleshoot_2_large.png": "Miss World Australia candidates",
  "20240626_OZwear_AW2416630.jpg": "UGG Classic Plus Ultra Boots (Unisex)",
  "esma_large.png": "Esma Voloder wearing Ozwear UGG boots",
  "Screen_Shot_2017-07-16_at_8.46.52_pm_large.png": "Crowning Miss World Australia",
  "maddie_sash_large.jpg": "Miss World Australia winner Madeline Cowe wearing Ozwear UGG boots",
  "han_jin_1_large.JPG": "Ozwear UGG was one of the sponsors of The Voice China 2016",
  "Pettifleur_large.jpg": "Pettifleur Berenger from 'The Real Housewives of Melbourne' & 'Hell's Kitchen'",
  "20240626_OZwear_AW2415148.jpg": "UGG Violet Shearling Loafer",
  "Tracey_jewel_large.jpg": "Tracey Jewel from 'Married at First Sight'",
  "Daily_Telegraph_large.png": "NSW Miss World contestants",
  "Banner_JASON_20_1024x1024.jpg": "Australia’s most iconic UGG boots",
  "Apollo_large.jpg": "Apollo Jackson from 'The Bachelorette' and 'Bachelor in Paradise'",
  "20240626_OZwear_AW2415532.jpg": "UGG Sydney Plus Slipper (Unisex)",
  "20240626_OZwear_AW2416277.jpg": "UGG Classic Plus Short Boots (Unisex)",
  "IMG_1111_large.PNG": "David from MKR wearing Ozwear UGG",
  "Banner_JASON_8_large.jpg": "Miss World Australia 2018 - Ozwear UGG as Title Sponsor",
  "SARAH_1_9ff3e680-bea1-4a97-a73e-8213680de856_480x480.jpg": "Miss World Australia 2019 - Ozwear UGG as Title Sponsor",
  "EOSS20OFF_1110x.progressive.jpg": "End of Season Sale - 20% OFF",
  "CLRcenter2_1110x.progressive.jpg": "Clearance Sale - Limited Time Only",
  "The_voice_of_China_large.png": "Ozwear UGG sponsored The Voice China in 2016",
  "DSC_1439_large.jpg": "Miss World Australia 2017 - Ozwear UGG as Title Sponsor",
  "20240626_OZwear_AW2415597.jpg": "UGG Ashton Short Boots",
  "teleshoot_large.png": "Miss World finalists",
  "Screen_Shot_2017-06-24_at_10.10.42_am_large.png": "David from MKR wearing Ozwear UGG",
  "Runway_large.jpg": "Miss World Australia Winner - Ozwear UGG as Title Sponsor",
  "Sunrise_large.jpg": "Miss World Australia - Ozwear UGG as Title Sponsor",
  "20240626_OZwear_AW2415580.jpg": "UGG Classic Plus Ankle Boots (Unisex)",
  "Studio_10_large.jpg": "Shoe Shopping with Miss World Australia",
  "Bachelorette_girls_large.jpg": "The Bachelorette' with Ozwear UGG Boots",
  "20240626_OZwear_AW2415774.jpg": "UGG OZ Shearling Clog",
  "20240626_OZwear_AW2415117.jpg": "UGG Phone Bag",
  "20240626_OZwear_AW2415014.jpg": "UGG Fluffy Shoulder Bag",
  "20240626_OZwear_AW2415067.jpg": "UGG Gianna Mini Tote Bag",
  "1_560c075a-d572-4aae-a3be-73b838425df1_480x480.jpg": "Miss World Australia 2019 - Ozwear UGG as Title Sponsor",
  "20240626_OZwear_AW2415034.jpg": "UGG Shearling Shoulder Bag",
  "20240626_OZwear_AW2415109.jpg": "UGG Box Bag",
  "20240626_OZwear_AW2415080.jpg": "UGG Gianna Mini Tote Bag",
  "20240626_OZwear_AW2415132.jpg": "UGG Fluffy Bucket Bag",
  "20240626_OZwear_AW2414334.jpg": "UGG Violet Shearling Slipper",
  "20240626_OZwear_AW2416358.jpg": "UGG Classic Platform Buckle Tall Boots in Chestnut",
  "20240626_OZwear_AW2414298.jpg": "UGG Violet Shearling Slipper",
  "20240626_OZwear_AW2414373.jpg": "UGG Violet Shearling Slipper",
  "20240626_OZwear_AW2414400.jpg": "UGG Violet Shearling Slipper",
  "20240626_OZwear_AW2414334_6fb89e90-88c4-4f53-934f-5f088ce3f641.jpg": "UGG Violet Shearling Slipper",
  "20240626_OZwear_AW2414989.jpg": "UGG Violet Shearling Slipper",
  "20240626_OZwear_AW2414283.jpg": "UGG Violet Shearling Slipper",
  "20240626_OZwear_AW2414693.jpg": "",
  "20240626_OZwear_AW2415618.jpg": "UGG Classic Platform Buckle Mini Boots",
  "20240626_OZwear_AW2415614.jpg": "UGG Classic Platform Buckle Mini Boots",
  "20240626_OZwear_AW2415607.jpg": "UGG Classic Platform Buckle Mini Boots",
  "crazy_secure_01.png": "Secured Website",
  "crazy_secure_02.png": "Safe Shopping",
  "IMG_3824.jpg": "UGG Classic Plus Mini Boots (Unisex)",
  "maddie_sash_large.jpg": "Miss World Australia Winner - Madeline Cowe",
  "Family_Tree_Small_1__00.jpg": "Ozwear UGG Boot Brands",
  "Runway_large.jpg": "Miss World Australia 2016 - Ozwear UGG as Title Sponsor",
  "Sunrise_large.jpg": "Miss World Australia 2016 - Ozwear UGG as Title Sponsor"
};

// Step 2: Loop through images and set alt if src contains filename
document.querySelectorAll('img').forEach(img => {
  const src = img.getAttribute('src');
  if (src) {
    for (const [filename, altText] of Object.entries(imageAltMap)) {
      if (src.includes(filename)) {
        img.alt = altText;
        break; // Stop checking once matched
      }
    }
  }
});
